import * as React from 'react';
import { withRouter } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import Button from '../../components/Button/Button';
import LinkButton from '../../components/Button/LinkButton';
import classNames from 'classnames';
import validate from '../Profile/validate';
import { getFormValues } from 'redux-form';
import { postProfile } from '../../models/Profile';
import { connect } from 'react-redux';
import Icon from 'react-fa';
import times from 'lodash/times';
import inRange from 'lodash/inRange';
import get from 'lodash/get';
const styles = require('./Wizard.less') as any;

const ProgressBar = ({steps, step=1}) => (
		<div className={styles.ProgressBar}>
				{times(steps, (idx) => (
						 <div className={classNames(
										 step > idx + 1 && styles.CompletedStep,
										 step === idx + 1 && styles.CurrentStep
								 )}></div>
				 ))}
		</div>
);

const WizardNav = ({steps, step=1, onSubmit, handle}) => {
		return (
				<div className={styles.WizardNav}>
						<div className={styles.ProgressNav}>
								<LinkButton to={`/wizard/${step-1}/`} style={step>1 ? {} : {visibility: 'hidden'}}>
										<Icon name='caret-left' /> Prev</LinkButton>
										<div className={styles.Progress}>
												<ProgressBar {...({steps, step})} />
												{`${step} out of ${steps}`}
										</div>
										{step < steps && (
                         <Button type='submit' onSubmit={() => onSubmit(step + 1)}>Next <Icon name='caret-right' /></Button>)}
										     {step === steps && <Button onSubmit={onSubmit}>Finish</Button>}
						</div>
						{inRange(step, 1, steps) && <LinkButton kind='secondary' to='/Search/'>Finish Later</LinkButton>}
				</div>
		);
};

import Demographics from './Pages/Demographics';
import Demographics2 from './Pages/Demographics2';
import Health from './Pages/Health';
import Health2 from './Pages/Health2';
import Health3 from './Pages/Health3';
import AT from './Pages/AT';
import Intro from './Pages/Intro';
const pages = [Intro, Demographics, Demographics2, Health, Health2, Health3, AT];

const PageHelper = reduxForm({
		form: 'Wizard', destroyOnUnmount: false,
		enableReinitialize: true, keepDirtyOnReinitialize: true,
		validate
})(({handleSubmit, onSubmit, Page, step, steps, post, relationship, firstName}) => (
		<form onSubmit={handleSubmit} className={styles.Wizard}>
				<Page relationship={relationship} firstName={firstName} />
				<Field name='completion' component='input' type='hidden' input={{value: step}} />
				<WizardNav {...{steps, step, onSubmit, handle: post}} />
		</form>
));

const mapStateToProps = (state, ownProps) => ({
    initialValues: {...get(state, 'profile.data', {} as any), selected_disability_areas: []},
    relationship: get(getFormValues('Wizard')(state), 'describes', ''),
    firstName: get(getFormValues('Wizard')(state), 'name', '').split(' ')[0]
});
const Page = connect(mapStateToProps, { postProfile })(
		(({ params: {page='1'}, handleSubmit, router, relationship, firstName, initialValues, ...props }) => {
				const page_num = parseInt(page);
				const steps = pages.length;
				const step = page_num;
        const post = (profile) => {
            (props as any).postProfile({...profile, completion: Math.max(profile.completion, step)});
            router.push(`/search/`);
        };
				const next = (profile) => {
            (props as any).postProfile({...profile, completion: Math.max(profile.completion, step)})
            //.then(() => untouch(...[]));
            router.push(`/wizard/${page_num+1}/`);
        };
				const onSubmit = step === steps ? post : next;
				return <PageHelper {...{steps, step, onSubmit, post, Page: pages[page_num-1], relationship, firstName, initialValues}} />;
		}));

export default withRouter(Page);



// WEBPACK FOOTER //
// ./src/app/containers/Wizard/Page.tsx